import { checklistConnectedActionTypes } from '@bridebook/web/lib/connected-actions/checklist/actions';
import { checklistActionsHandler } from '@bridebook/web/lib/connected-actions/checklist/handler';

export default {
  checklistConnectedActionTypes,
  checklistActionsHandler,
};
